import * as React from 'react';

import { PromoContactModal } from './PromoDescriptionModal/PromoContactModal/PromoContactModal';
import { PromoDescriptionModal } from './PromoDescriptionModal/PromoDescriptionModal';
import { PromoItem } from './PromoItem';
import { trackContactButtonClick, trackPromoClick } from './tracking';
import { IPromotions } from '../../types/villagePromotions';

interface IPromoProps {
  builderName?: string | null;
  logoUrl?: string | null;
  phone?: string;
  promo: IPromotions;
  index: number;
  offerId: number;
}

export function VillagePromotion({ promo, builderName, logoUrl, phone, index, offerId }: IPromoProps) {
  const [isDescriptionModalOpen, setDescriptionModalOpen] = React.useState(false);
  const [isContactModalOpen, setContactModalOpen] = React.useState(false);

  const handleOpenDescriptionModal = () => {
    trackPromoClick({ id: offerId, type: promo.type, actionPosition: index + 1, actionId: promo.id });
    setDescriptionModalOpen(true);
  };
  const handleOpenContactModal = () => {
    trackContactButtonClick({ id: offerId, type: promo.type, actionPosition: index + 1, actionId: promo.id });
    setDescriptionModalOpen(false);
    setContactModalOpen(true);
  };

  const promoSubtitle = promo.subtitle || (promo.endDate ? `Действует до ${promo.endDate}` : undefined);

  return (
    <>
      <PromoItem
        name={promo.name}
        type={promo.type}
        subtitle={promoSubtitle}
        iconUrl={promo.promoLogoUrl}
        onClick={handleOpenDescriptionModal}
      />
      <PromoDescriptionModal
        open={isDescriptionModalOpen}
        onClose={() => setDescriptionModalOpen(!isDescriptionModalOpen)}
        handleOpenContactModal={handleOpenContactModal}
        name={promo.name}
        description={promo.description}
        subtitle={promoSubtitle}
        promoType={promo.type}
        builderName={builderName}
        logoUrl={logoUrl}
        phoneNumber={phone}
      />
      <PromoContactModal
        open={isContactModalOpen}
        onClose={() => setContactModalOpen(!isContactModalOpen)}
        builderName={builderName}
        logoUrl={logoUrl}
        phoneNumber={phone}
      />
    </>
  );
}
